import { render } from "./BadPersonReview.vue?vue&type=template&id=a62d7728&scoped=true"
import script from "./BadPersonReview.vue?vue&type=script&lang=js"
export * from "./BadPersonReview.vue?vue&type=script&lang=js"

import "./BadPersonReview.vue?vue&type=style&index=0&id=a62d7728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a62d7728"]])

export default __exports__